<template>
    <v-dialog v-model="open" max-width="600px">
      <v-card>
        <v-card-title>Escalate</v-card-title>

        <v-card-text>
          <v-textarea v-model="note" label="Escalation Note" :error-messages="noteError" placeholder outlined @input="$v.note.$touch()" @blur="$v.note.$touch()"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small :disabled="saving" :loading="saving" @click="save">Escalate</v-btn>
          <v-btn color="primary" outlined small :disabled="saving" @click="closeDialog">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  validations: {
    note: { required },
  },

  props: {
    open: Boolean,
    close: Function,
    account: Number
  },

  data: () => ({
    note: "",
    saving: false,
  }),

  computed: {
    noteError() {
      const errors = [];
      if (!this.$v.note.$dirty) return errors;
      !this.$v.note.required && errors.push("Escalation note is required");
      return errors;
    },

    date() {
      return moment().add("days", Number(this.days)).format("DD/MM/YYYY");
    }
  },

  methods: {
    ...mapActions("accounts", ["addEscalation", "getAccountEscalation"]),

    async save() {
      if(!this.$v.$invalid) {
        this.saving = true;
        
        try {
          await this.addEscalation({id: this.account, data: {text: this.note}});
          this.getAccountEscalation(this.$route.params.id);
          this.saving = false;
          this.closeDialog();
        } catch(error) {
            this.saving = false;
        }
      }
    },

    closeDialog() {
      this.clearData();
      this.close();
      this.$v.$reset();
    },

    clearData() {
      this.note = "";
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
